import React, { useEffect, useState } from "react";
import AccountPagesHeader from "../components/AccountPagesHeader";
import { Link, useNavigate } from "react-router-dom";
import SuccessAlert from "../admin/components/SuccessAlert";
import ErrorAlert from "../admin/components/ErrorAlert";

export default function Signup() {
  const navigate = useNavigate();

  // State Handling
  const [usersData, setUsersData] = useState({
    user_img: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_password: "",
    user_home_address: "",
    user_phone_number: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // --------- Creating ---------
  // Upload Image Handling
  const userImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setUsersData({
          ...usersData,
          user_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  // Form Submission To Add Place In DataBase
  const usersSubmitHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setLoading(true);
    try {
      // Sending Data to Database
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/add-users-toDb",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(usersData),
        }
      );

      // Checking Response and setting success or error messages
      if (!response.ok) {
        setSuccess("");

        if (response.status === 413) {
          setError("Image is too big, Max Image Size = 1mb");
        } else {
          setError("Error Occurred, Something went wrong");
        }
      } else {
        setError("");
        setSuccess("Account Created Successfully");

        setTimeout(() => {
          setSuccess("");
          navigate("/login");
        }, 2000);

        // Clearing The Form
        setUsersData({
          user_img: "",
          user_first_name: "",
          user_last_name: "",
          user_email: "",
          user_password: "",
          user_home_address: "",
          user_phone_number: "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div class="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div class="spinner-grow" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Creating Your Account</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Header Start */}
        <AccountPagesHeader status="Creating a new account" />
        {/* Header End */}

        {/* Showing Alert based on http request response Start */}
        <div className="container-fluid p-0">
          <div className="row app-container mt-3">
            {success && <SuccessAlert successMsg={success} />}
            {error && <ErrorAlert errorMsg={error} />}
          </div>
        </div>
        {/* Showing Alert based on http request response End */}

        {/* Signup Form Start */}
        <div className="container-fluid p-0">
          <div className="row app-container signup-form-cover">
            <form method="post" className="p-0" onSubmit={usersSubmitHandler}>
              <div className="d-flex justify-content-center align-items-center">
                <div className="p-0 m-0 upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                  <i className="fa-solid fa-camera"></i>
                  <input
                    type="file"
                    name="user_img"
                    required
                    className="profile-pic-input"
                    onChange={userImgHandler}
                  />
                  {usersData.user_img ? (
                    <img
                      src={usersData.user_img}
                      alt="place-img"
                      className="img-fluid"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <input
                    type="text"
                    name="user_first_name"
                    placeholder="First Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_first_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_first_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <input
                    type="text"
                    name="user_last_name"
                    placeholder="Last Name"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_last_name}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_last_name: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>

              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email"
                    className="form-control"
                    required
                    value={usersData.user_email}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_email: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <input
                    type="password"
                    name="user_password"
                    placeholder="Password"
                    className="form-control"
                    required
                    value={usersData.user_password}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_password: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>

              <div className="d-flex gap-3 signup-form-row">
                <div className="col p-0 signup-col">
                  <input
                    type="text"
                    name="user_home_address"
                    placeholder="Home Address"
                    className="form-control text-capitalize"
                    required
                    value={usersData.user_home_address}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_home_address: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
                <div className="col p-0 signup-col">
                  <input
                    type="text"
                    name="user_phone_number"
                    placeholder="Mobile Number"
                    className="form-control"
                    required
                    value={usersData.user_phone_number}
                    onChange={(e) => {
                      setUsersData({
                        ...usersData,
                        user_phone_number: e.target.value.toLowerCase(),
                      });
                    }}
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
              >
                Create Account
              </button>
            </form>
          </div>
          <Link
            to="/login"
            className="d-block mb-4 text-center text-decoration-none signup-link"
          >
            Already have an account? Login
          </Link>
        </div>
        {/* Signup Form End */}
      </>
    );
}
